import {Delegate} from "../Tools/Delegate.js";

export const OnTemplateDelete = new Delegate();
export const OnTemplateAdd = new Delegate();
export const OnTemplateUpdate = new Delegate();
/**
 * Fire avec la Primarykey du PIVOT après l'enregistrement d'un groupe i18n
 * (pivot + traductions). Sert à invalider le cache du groupe côté liste pour
 * que la réouverture recharge toutes les langues depuis l'API.
 */
export const OnTemplateGroupSaved = new Delegate();
